import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class B2BGeneralReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dailyGeneralReport',
      requesterInfo,
    })
  }

  // Mails boş bırakılırsa koddaki varsayılan adreslere gönderilir.
  public async sendB2BGeneralReport(req: { StartDate: Date; EndDate: Date; Mails?: string[] }): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
